// services/OrganizationService.js - Fixed with proper async/await
import { organizationCachedAxios, noCacheAxios, invalidateCache } from '../../../shared/config/cachedAxiosConfig';
import { getAuthHeaders } from '../../../shared/services/auth/authHeaders';
import { ORGANIZATION_ENDPOINTS } from '../config/organizationApiEndpoints';
import logger from '../../../shared/services/logging/logger';
import { validateOrgId, validateNonEmptyString } from '../utils/validators';

export const OrganizationService = {
  // Get organization theme
  getTheme: async (orgId) => {
    validateOrgId(orgId);

    try {
      // FIXED: Await the async getAuthHeaders function
      const headers = await getAuthHeaders();
      
      const response = await organizationCachedAxios.get(ORGANIZATION_ENDPOINTS.getTheme(orgId), { headers });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      logger.error('Failed to get organization theme', { method: 'getTheme', error: error.message, orgId });
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Update organization theme
  updateTheme: async (orgId, themeName) => {
    validateOrgId(orgId);
    validateNonEmptyString(themeName, 'Theme name');

    try {
      // FIXED: Await the async getAuthHeaders function
      const headers = await getAuthHeaders();

      const requestData = {
        orgTheme: themeName,
        organizationId: orgId
      };
      
      const response = await noCacheAxios.put(
        ORGANIZATION_ENDPOINTS.updateTheme(orgId),
        requestData,
        { headers }
      );

      // Invalidate organization cache after updating theme
      invalidateCache(organizationCachedAxios);

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      logger.error('Failed to update organization theme', { method: 'updateTheme', error: error.message, orgId });
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Get organization details
  getOrganizationDetails: async (orgId) => {
    validateOrgId(orgId);

    try {
      // FIXED: Await the async getAuthHeaders function
      const headers = await getAuthHeaders();
      
      const response = await organizationCachedAxios.get(ORGANIZATION_ENDPOINTS.getDetails(orgId), { headers });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      logger.error('Failed to get organization details', { method: 'getOrganizationDetails', error: error.message, orgId });
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },

  // Update organization details
  updateOrganization: async (orgId, organizationData) => {
    validateOrgId(orgId);

    try {
      // FIXED: Await the async getAuthHeaders function
      const headers = await getAuthHeaders();
      
      const response = await noCacheAxios.put(
        ORGANIZATION_ENDPOINTS.update(orgId),
        organizationData,
        { headers }
      );

      // Invalidate organization cache after updating organization
      invalidateCache(organizationCachedAxios);

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      logger.error('Failed to update organization', { method: 'updateOrganization', error: error.message, orgId });
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  }
};

export default OrganizationService;